const ChargeListStatusConstants = {
    DRAFT: 0,
    ACTIVE: 1,
    CLOSED: 2
}

export default ChargeListStatusConstants